// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { fetchCompanyInfo } from 'src/redux/company-info';
import { fetchHistory } from 'src/redux/history';
import Tabs from './Tabs';

const CompanyOverview = loadable(() =>
  import(/* webpackPreload: true */ './Overview')
);
const CompanyHistory = loadable(() =>
  import(/* webpackPreload: true */ './History')
);

const Info = ({
  companyInfo,
  histories,
  _fetchHistory,
}: {
  histories: Object,
  _fetchHistory: Function,
}) => {
  useEffect(() => {
    _fetchHistory();
  }, []);

  return (
    <Tabs
      id="overview"
      title="プロフィール"
      tabs={[
        { id: 'overview', label: '会社情報' },
        { id: 'history', label: '沿革' },
      ]}
      contents={[
        {
          id: 'overview',
          component: <CompanyOverview companyInfo={companyInfo} />,
        },
        {
          id: 'history',
          component: histories && <CompanyHistory histories={histories} />,
        },
      ]}
    ></Tabs>
  );
};

const mapStateToProps = (state) => ({
  companyInfo: state.companyInfo.data,
  histories: state.history.data,
});

const mapDispatchToProps = (dispatch: Function) => ({
  _fetchCompanyInfo: () => dispatch(fetchCompanyInfo()),
  _fetchHistory: () => dispatch(fetchHistory()),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(Info);
